import { HttpInterceptorFn } from '@angular/common/http';

// Avoid injecting LanguageService here to prevent a circular DI dependency
// (LanguageService/TranslateService may depend on HttpClient). Read the
// persisted language from localStorage or document element instead.
export const languageInterceptor: HttpInterceptorFn = (req, next) => {
  let lang = 'en';
  try {
    if (typeof window !== 'undefined' && window.localStorage) {
      lang = (localStorage.getItem('dms_lang') as string) || (document?.documentElement?.lang as string) || 'en';
    } else if (typeof document !== 'undefined') {
      lang = (document.documentElement.lang as string) || 'en';
    }
  } catch (e) {
    lang = 'en';
  }

  const header = (typeof lang === 'string' ? lang : 'en').toUpperCase();
  req = req.clone({ setHeaders: { 'Accept-Language': header } });
  return next(req);
};


